import { lazy, ReactNode, Suspense } from 'react'
import { BrowserRouter, Outlet, Route, Routes } from 'react-router-dom'

import { AuthProvider, RequireAuth } from 'state'

import { Layout } from 'components/Layout'

const Home = lazy(() => import('./pages/home'))
const Portal = lazy(() => import('./pages/portal'))
const AppDownload = lazy(() => import('./pages/app/download'))

const withOutlet = (Component: React.ComponentType) => (props: any) => {
  return (
    <Component {...props}>
      <Outlet />
    </Component>
  )
}

const RequiredAuthWithOutlet = withOutlet(RequireAuth)
const LayoutWithOutlet = withOutlet(Layout)

const createHolder = (content: ReactNode) => <div>{content}</div>

export function Router() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Suspense>
          <Routes>
            {/* 公共页面（无需登录） */}
            <Route path='/app/download' element={<AppDownload />} />

            <Route element={<RequiredAuthWithOutlet />}>
              <Route path='/' element={<Portal />} />
              {/* <Route element={<LayoutWithOutlet />}>
                <Route index element={createHolder('default')} />
                <Route path='/home' element={<Home />} />
                <Route
                  path='/home/detail'
                  element={createHolder('home detail')}
                />
                <Route path='/Store' element={createHolder('/Store')} />
                <Route
                  path='/StoreOpening/TalentPlanning'
                  element={createHolder('/StoreOpening/TalentPlanning')}
                />
                <Route
                  path='/StoreOpening/TalentPlanning/Detail'
                  element={createHolder('/StoreOpening/TalentPlanning/Detail')}
                />
                <Route
                  path='/StoreOpening/CityManage'
                  element={createHolder('/StoreOpening/CityManage')}
                />
                <Route
                  path='/StoreOpening/ProjectList'
                  element={createHolder('/StoreOpening/ProjectList')}
                />
                <Route
                  path='/StoreOpening'
                  element={createHolder('/StoreOpening')}
                />
                <Route
                  path='/StoreOpening/ProjectTalentMatch'
                  element={createHolder('/StoreOpening/ProjectTalentMatch')}
                />
                <Route
                  path='/StoreOpening/PartnershipArea/Manage'
                  element={createHolder('/StoreOpening/PartnershipArea/Manage')}
                />
                <Route
                  path='/StoreOpening/PartnershipArea/Map'
                  element={createHolder('/StoreOpening/PartnershipArea/Map')}
                />
                <Route
                  path='/StoreOpening/Dev/Manage'
                  element={createHolder('/StoreOpening/Dev/Manage')}
                />
                <Route
                  path='/StoreOpening/Dev/Map'
                  element={createHolder('/StoreOpening/Dev/Map')}
                />
                <Route
                  path='/StoreOpening/ProjectPreview'
                  element={createHolder('/StoreOpening/ProjectPreview')}
                />
                <Route
                  path='/Amortization'
                  element={createHolder('/Amortization')}
                />
                <Route
                  path='/Amortization/Base'
                  element={createHolder('/Amortization/Base')}
                />
                <Route
                  path='/Amortization/Base/TypeList'
                  element={createHolder('/Amortization/Base/TypeList')}
                />
                <Route
                  path='/Amortization/manage'
                  element={createHolder('/Amortization/manage')}
                />
                <Route
                  path='/Amortization/manage/project/list'
                  element={createHolder('/Amortization/manage/project/list')}
                />
                <Route
                  path='/Amortization/manage/change/list'
                  element={createHolder('/Amortization/manage/change/list')}
                />
                <Route
                  path='/Amortization/manage/stand/list'
                  element={createHolder('/Amortization/manage/stand/list')}
                />
                <Route
                  path='/Amortization/manage/deal/list'
                  element={createHolder('/Amortization/manage/deal/list')}
                />
                <Route
                  path='/Amortization/manage/check/list'
                  element={createHolder('/Amortization/manage/check/list')}
                />
                <Route path='/Engine' element={createHolder('/Engine')} />
                <Route
                  path='/Engine/OrderGroup'
                  element={createHolder('/Engine/OrderGroup')}
                />
                <Route
                  path='/Engine/Source'
                  element={createHolder('/Engine/Source')}
                />
                <Route
                  path='/Engine/Task'
                  element={createHolder('/Engine/Task')}
                />
                <Route
                  path='/Engine/Tpl'
                  element={createHolder('/Engine/Tpl')}
                />
                <Route
                  path='/Engine/Log'
                  element={createHolder('/Engine/Log')}
                />
                <Route path='/Flow' element={createHolder('/Flow')} />
                <Route
                  path='/Flow/FlowList'
                  element={createHolder('/Flow/FlowList')}
                />
                <Route
                  path='/MainReport'
                  element={createHolder('/MainReport')}
                />
                <Route
                  path='/MainReport/Company'
                  element={createHolder('/MainReport/Company')}
                />
                <Route
                  path='/MainReport/EC'
                  element={createHolder('/MainReport/EC')}
                />
                <Route path='/Product' element={createHolder('/Product')} />
                <Route
                  path='/Product/Menu/List'
                  element={createHolder('/Product/Menu/List')}
                />
                <Route path='/Meeting' element={createHolder('/Meeting')} />
                <Route
                  path='/Meeting/Table'
                  element={createHolder('/Meeting/Table')}
                />
                <Route
                  path='/Meeting/User'
                  element={createHolder('/Meeting/User')}
                />
              </Route> */}
            </Route>
            <Route path='*' element={createHolder('404')} />
          </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
  )
}
